import { render, staticRenderFns } from "./BookFddIcon.vue?vue&type=template&id=6458bfb1&"
import script from "./BookFddIcon.vue?vue&type=script&lang=js&"
export * from "./BookFddIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports